import React, { useState } from 'react';
import Icon from '../../../../components/AppIcon';
import Button from '../../../../components/ui/Button';


const FeedbackForm = ({ onSubmit }) => {
  const [overallRating, setOverallRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [questionRatings, setQuestionRatings] = useState({
    difficulty: 0,
    relevance: 0,
    clarity: 0
  });
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOverallRating = (rating) => {
    setOverallRating(rating);
  };

  const handleQuestionRating = (category, rating) => {
    setQuestionRatings(prev => ({
      ...prev,
      [category]: rating
    }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setIsSubmitting(true);
    
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    if (onSubmit) {
      onSubmit({
        overallRating,
        questionRatings,
        comment
      });
    }
    
    setIsSubmitting(false);
  };

  const StarRating = ({ rating, onRate, onHover, hoveredValue, size = 24 }) => {
    return (
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5]?.map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onRate(star)}
            onMouseEnter={() => onHover && onHover(star)}
            onMouseLeave={() => onHover && onHover(0)}
            className="transition-transform duration-150 ease-out hover:scale-110"
          >
            <Icon 
              name={star <= (hoveredValue || rating) ? 'Star' : 'Star'}
              size={size}
              color={star <= (hoveredValue || rating) ? 'var(--color-warning)' : 'var(--color-muted)'}
              className={star <= (hoveredValue || rating) ? 'fill-warning' : ''}
            />
          </button>
        ))}
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit} className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Share Your Feedback
        </h3>
      </div>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Overall Experience
          </label>
          <div className="flex items-center gap-4">
            <StarRating 
              rating={overallRating}
              onRate={handleOverallRating}
              onHover={setHoveredRating}
              hoveredValue={hoveredRating}
              size={32}
            />
            {overallRating > 0 && (
              <span className="text-sm font-medium text-muted-foreground">
                {overallRating} out of 5
              </span>
            )}
          </div>
        </div>

        <div className="space-y-4">
          <label className="block text-sm font-medium text-foreground mb-2">
            Rate Specific Aspects
          </label>
          
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Question Difficulty</span>
              <StarRating 
                rating={questionRatings?.difficulty}
                onRate={(rating) => handleQuestionRating('difficulty', rating)}
                onHover={() => {}}
                hoveredValue={0}
                size={20}
              />
            </div>

            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Question Relevance</span>
              <StarRating 
                rating={questionRatings?.relevance}
                onRate={(rating) => handleQuestionRating('relevance', rating)}
                onHover={() => {}}
                hoveredValue={0}
                size={20}
              />
            </div>

            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Question Clarity</span>
              <StarRating 
                rating={questionRatings?.clarity}
                onRate={(rating) => handleQuestionRating('clarity', rating)}
                onHover={() => {}}
                hoveredValue={0}
                size={20}
              />
            </div>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Additional Comments
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e?.target?.value)}
            placeholder="Share your thoughts about the interview experience, what went well, and what could be improved..."
            rows={6}
            className="w-full px-4 py-3 bg-background border border-input rounded-md text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-all duration-150 ease-out resize-none"
          />
        </div>

        <Button 
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          loading={isSubmitting}
          iconName="Send"
          iconPosition="right"
          disabled={overallRating === 0}
        >
          Submit Feedback
        </Button>
      </div>
    </form>
  );
};

export default FeedbackForm;